// FILE: src/components/RestaurantListItem.js

import React from 'react';
import { Star, MapPin, Tag, Heart } from 'lucide-react';

export default function RestaurantListItem({ restaurant, onSelect, isFavorite, toggleFavorite }) {

    const handleFavoriteClick = (e) => {
        e.stopPropagation();
        toggleFavorite(restaurant.id);
    };

    return (
        <div className="bg-white rounded-lg shadow-md overflow-hidden flex transform hover:shadow-xl transition-all duration-300 ease-in-out cursor-pointer" onClick={() => onSelect(restaurant)}>
            <div className="w-1/4">
                <img src={restaurant.imageUrl} alt={`Cuisine at ${restaurant.name}`} className="w-full h-full object-cover" onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/400x400/cccccc/ffffff?text=Image'; }} />
            </div>
            <div className="w-3/4 p-4 flex flex-col justify-between">
                <div>
                    <div className="flex justify-between items-start">
                        <div>
                            <span className="bg-teal-500 text-white text-xs font-semibold px-2 py-1 rounded-full">{restaurant.cuisine}</span>
                            <h3 className="text-xl font-bold text-gray-800 mt-1">{restaurant.name}</h3>
                            <p className="text-xs text-gray-500 flex items-center gap-1"><MapPin size={12}/> {restaurant.address}</p>
                        </div>
                        <button onClick={handleFavoriteClick} className="p-2 rounded-full hover:bg-gray-100">
                            <Heart className={`w-5 h-5 ${isFavorite ? 'text-red-500 fill-current' : 'text-gray-600'}`} />
                        </button>
                    </div>
                    <div className="flex items-center text-xs text-gray-500 my-2">
                        <div className="flex items-center">
                            <Star className="w-4 h-4 text-yellow-500 mr-1" fill="currentColor" />
                            <span className="font-bold text-gray-700">{restaurant.rating}</span>
                        </div>
                        <span className="mx-2 text-gray-300">|</span>
                        <span className="font-bold text-base text-gray-700">{restaurant.priceRange}</span>
                        {restaurant.distance != null && (
                            <>
                                <span className="mx-2 text-gray-300">|</span>
                                <MapPin className="w-4 h-4 text-red-500 mr-1" />
                                <span>{restaurant.distance.toFixed(1)} km away</span>
                            </>
                        )}
                    </div>
                </div>
                <div className="border-t pt-2 mt-2">
                    <h4 className="font-semibold text-gray-600 text-xs mb-1 flex items-center gap-1"><Tag size={14}/> Top Vouchers</h4>
                    <div className="space-y-1">
                        {(restaurant.vouchers || []).slice(0, 2).map(voucher => (
                             <div key={voucher.id} className="bg-green-50 text-green-800 text-xs p-1.5 rounded-md border border-green-200">
                                <p className="font-bold">{voucher.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
